import api from '../../../../App/socket';

export const removeUserPhone = (phone_id, user_id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedDelete',
        options: {
            fullPath: `person.phones.${phone_id}`,
            where: {
                _id: user_id,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_phones_requests/remove_user_phone_request.js